<template>
  <v-container fluid>
    <!-- Banner Section -->
    <!-- <v-row justify="center">
      <v-col cols="12" class="d-flex justify-center">
        <v-img src="@/assets/bannersample.png" alt="JStick Banner" class="banner-image"></v-img>
      </v-col>
    </v-row> -->
    <v-card-title>
        <v-icon class="me-2">mdi-image</v-icon>
        Section
      </v-card-title>
      <v-card-subtitle>Manage your section content here</v-card-subtitle>
      <v-card-actions>
        <v-btn @click="openAddDialog" color="primary">
          <v-icon left>mdi-plus</v-icon>
          Add Section
        </v-btn>
      </v-card-actions>

    <!-- Add Section Button -->
    <!-- <v-row class="mb-4">
      <v-col cols="12" class="d-flex justify-center">
        <v-btn @click="openAddDialog" color="primary" elevation="2">Add Section</v-btn>
      </v-col>
    </v-row> -->

    <!-- Sections List -->
    <v-row v-if="!loading && default_card.length">
      <v-col v-for="(section, index) in default_card" :key="section.id" cols="12" md="6">
        <v-card class="mx-auto my-4 modern-card" color="#ECEFF1" max-width="1200">
          <v-row no-gutters>
            <v-col cols="12" md="6">
              <v-img :src="getImageUrl(section.image)" height="100%" contain></v-img>
            </v-col>
            <v-col cols="12" md="6" class="pa-4">
              <h1 class="card-title">{{ section.title }}</h1>
              <h3 class="card-subtitle">{{ section.subtitle }}</h3>
              <v-card-text>{{ section.text }}</v-card-text>
              <v-card-actions>
                <v-btn 
                  @click="openEditDialog(section)" 
                  color="primary" 
                  variant="flat" 
                  size="small" 
                  prepend-icon="mdi-pencil"
                >
                  Edit
                </v-btn>
                <v-btn 
                  @click="openDeleteDialog(section.section_id)" 
                  color="error" 
                  variant="flat" 
                  size="small" 
                  prepend-icon="mdi-delete"
                >
                  Delete
                </v-btn>
              </v-card-actions>

            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- Loading Indicator -->
    <v-row v-if="loading">
      <v-col class="text-center">
        <v-spinner></v-spinner>
      </v-col>
    </v-row>

    <!-- No Data Message -->
    <v-row v-else-if="!default_card.length && !loading">
      <v-col class="text-center">
        <p>No sections available.</p>
      </v-col>
    </v-row>

    <!-- Dialogs for Adding and Editing Sections -->
    <v-dialog v-model="dialog" max-width="600" persistent scrollable>
  <v-card>
    <v-toolbar>
      <v-toolbar-title><strong>{{ editMode ? 'Edit Section' : 'Add Section' }}</strong></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-form @submit.prevent="saveSection">
        <v-text-field
        variant="outlined"
          v-model="currentSection.title"
          label="Title"
          required
        ></v-text-field>
        <v-text-field
        variant="outlined"
          v-model="currentSection.subtitle"
          label="Subtitle"
          required
        ></v-text-field>
        <v-textarea
        variant="outlined"
          v-model="currentSection.text"
          label="Text"
          required
        ></v-textarea>
        <v-text-field
        variant="outlined"
          v-model="currentSection.btn_text"
          label="Button Text"
          required
        ></v-text-field>
        <v-text-field
        variant="outlined"
          v-model="currentSection.btn_link"
          label="Button Link"
          required
        ></v-text-field>
        <v-file-input
        variant="outlined"
          v-model="currentSection.image"
          label="Image (Direkomendasikan 800 x 400 px)"
          accept="image/*"
        ></v-file-input>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-end">
      <div class="text-center">
        <v-btn
          prepend-icon="mdi-check-circle"
          type="submit"
          variant="flat"
          color="primary"
          @click="saveSection"
        >
          {{ editMode ? 'Save Changes' : 'Add Section' }}
        </v-btn>
        <v-btn
          prepend-icon="mdi-close-circle"
          @click="dialog = false"
          variant="flat"
          color="secondary"
        >
          Cancel
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</v-dialog>


    <!-- Dialog for Section Deletion Confirmation -->
    <v-dialog v-model="sectionDeleteDialog" max-width="400px">
  <v-card>
    <v-card-title class="headline">Delete Section</v-card-title>
    <v-card-text>Are you sure you want to delete this section?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn 
        color="primary" 
        variant="flat" 
        size="small" 
        prepend-icon="mdi-close" 
        @click="sectionDeleteDialog = false"
      >
        Cancel
      </v-btn>
      <v-btn 
        color="error" 
        variant="flat" 
        size="small" 
        prepend-icon="mdi-delete" 
        @click="confirmSectionDelete"
      >
        Delete
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<v-snackbar
      v-model="snackbar.visible"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.message }}
      <template v-slot:actions>
        <v-btn color="white" text @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      default_card: [], // Array to hold fetched sections
      loading: false, // Loading state
      dialog: false, // Dialog visibility
      editMode: false, // Flag to determine if editing or adding
      currentSection: { // Data model for current section
        id: '',
        title: '',
        subtitle: '',
        text: '',
        image: '',
        btn_text: '',
        btn_link: '',
      },
      sectionDeleteDialog: false, // Dialog visibility for section deletion
      sectionToDelete: '', // ID of section to delete
      snackbar: {
        visible: false,
        message: "",
        timeout: 5000,
      },
    };
  },
  async created() {
    await this.fetchSections();
  },
  methods: {
    showSnackbar(message, timeout = 3000) {
      this.snackbar.message = message;
      this.snackbar.timeout = timeout;
      this.snackbar.visible = true;
    },
    async fetchSections() {
      this.loading = true;
      try {
        const response = await this.$axios.get('/sections', {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        });
        this.default_card = response.data.data || [];
      } catch (error) {
        console.error('Error fetching sections:', error);
      } finally {
        this.loading = false;
      }
    },
    getImageUrl(imageName) {
      return `${this.$urlImage}storage/images/${imageName}`;
    },
    openAddDialog() {
      this.currentSection = { id: '', title: '', subtitle: '', text: '', image: '', btn_text: '', btn_link: '' };
      this.editMode = false;
      this.dialog = true;
    },
    openEditDialog(section) {
      this.currentSection = { ...section };
      this.editMode = true;
      this.dialog = true;
    },
    async saveSection() {
  const formData = new FormData();
  formData.append('title', this.currentSection.title || '');
  formData.append('subtitle', this.currentSection.subtitle || '');
  formData.append('text', this.currentSection.text || '');
  formData.append('btn_text', this.currentSection.btn_text || '');
  formData.append('btn_link', this.currentSection.btn_link || '');
  
  if (this.currentSection.image) {
    formData.append('image', this.currentSection.image);
  }

  try {
    if (this.editMode) {
      await this.$axios.post(`/sections/${this.currentSection.section_id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      });
    } else {
      await this.$axios.post('/sections', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      });
    }
    this.showSnackbar('Section succesfully saved')
    await this.fetchSections();
    this.dialog = false;
  } catch (error) {
    if (error.response && error.response.status == 422) {
      this.showSnackbar('Validation error')
    } else {
      this.showSnackbar('Error saving section')
    }
  }
},

    openDeleteDialog(sectionId) {
      this.sectionToDelete = sectionId;
      this.sectionDeleteDialog = true;
    },
    async confirmSectionDelete() {
      try {
        await this.$axios.delete(`/sections/${this.sectionToDelete}`, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        });
        this.showSnackbar('Section deleted')
        await this.fetchSections(); // Refresh section list
        this.sectionDeleteDialog = false;
      } catch (error) {
        this.showSnackbar('Error deleting section')
      }
    },
  },
};
</script>

<style scoped>
.banner-image {
  width: 100%;
  max-width: 1200px;
  height: auto;
  margin: 0 auto;
}

.v-card {
  border-radius: 12px;
}

.card-title, .card-subtitle, .card-text {
  color: #002250;
}

.card-title {
  font-size: 2rem;
}

.card-subtitle {
  font-size: 1.25rem;
}

.card-text {
  font-size: 1rem;
}

.v-card-actions {
  display: flex;
  justify-content: flex-start;
}
</style>
